/* Soporte — envío del formulario al Worker `tickets-web`.
   Sin dependencias y sin innerHTML: el aviso se compone con nodos, porque parte del
   texto viene del servidor. */
(function () {
  'use strict';

  var PORTAL = 'https://fluitronic-support.freshdesk.com/support/tickets/new';

  function init() {
    var raiz = document.querySelector('[data-sop]');
    if (!raiz || raiz.dataset.sopListo === '1') return;
    raiz.dataset.sopListo = '1';

    var form = raiz.querySelector('[data-sop-form]');
    var av = raiz.querySelector('[data-sop-aviso]');
    var btn = raiz.querySelector('[data-sop-enviar]');
    var endpoint = raiz.dataset.endpoint;
    if (!form || !endpoint) return;

    var etiquetaBtn = btn ? btn.textContent : 'Enviar';

    function limpiaAviso() {
      if (!av) return;
      av.hidden = true;
      av.textContent = '';
      av.className = 'sop__aviso';
    }

    /* `texto` siempre por textContent. El enlace, cuando hace falta, va como nodo. */
    function aviso(texto, clase, conEnlace) {
      if (!av) return;
      av.hidden = false;
      av.className = 'sop__aviso sop__aviso--' + clase;
      av.textContent = texto;
      if (conEnlace) {
        av.appendChild(document.createTextNode(' También puedes abrirlo en '));
        var a = document.createElement('a');
        a.href = PORTAL;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.textContent = 'el portal de soporte';
        av.appendChild(a);
        av.appendChild(document.createTextNode('.'));
      }
      av.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    /* Validación propia en vez de la del navegador: los mensajes nativos salen en el
       idioma del navegador y no en el de la web, y el foco no va al campo que falla. */
    function primerFallo() {
      var campos = form.querySelectorAll('[required]');
      for (var i = 0; i < campos.length; i++) {
        var c = campos[i];
        c.removeAttribute('aria-invalid');
        var v = (c.value || '').trim();
        var mal = !v ||
          (c.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) ||
          (c.name === 'mensaje' && v.length < 10);
        if (mal) { c.setAttribute('aria-invalid', 'true'); return c; }
      }
      return null;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      limpiaAviso();

      var malo = primerFallo();
      if (malo) {
        var etq = form.querySelector('label[for="' + malo.id + '"]');
        var nombre = etq ? etq.textContent.replace('*', '').trim() : 'un campo';
        aviso('Revisa «' + nombre + '»: falta o no tiene el formato correcto.', 'mal', false);
        malo.focus();
        return;
      }

      /* Los mismos topes que el Worker. Comprobarlos aquí no sustituye a la validación
         del servidor: evita que alguien espere la subida de 40 MB para que se la
         rechacen al final. */
      var MAX = 3, BYTES = 8 * 1024 * 1024, TOTAL = 20 * 1024 * 1024;
      var inputAdj = form.querySelector('input[type="file"]');
      var archivos = inputAdj && inputAdj.files ? inputAdj.files : [];
      if (archivos.length > MAX) {
        aviso('Puedes adjuntar como máximo ' + MAX + ' ficheros.', 'mal', false);
        inputAdj.focus(); return;
      }
      var suma = 0;
      for (var k = 0; k < archivos.length; k++) {
        suma += archivos[k].size;
        if (archivos[k].size > BYTES) {
          aviso('«' + archivos[k].name + '» pasa de 8 MB. Comprímelo o mándalo por separado.', 'mal', false);
          inputAdj.focus(); return;
        }
      }
      if (suma > TOTAL) {
        aviso('Los ficheros juntos pasan de 20 MB.', 'mal', false);
        inputAdj.focus(); return;
      }

      var fd = new FormData(form);
      /* Con ficheros se manda multipart; sin ellos, JSON. El Worker acepta las dos y
         distingue por el content-type. Aquí NO se pone el content-type a mano: el
         navegador le añade el `boundary`, y sin boundary el servidor no sabe partirlo. */
      var opciones;
      if (archivos.length) {
        opciones = { method: 'POST', body: fd };
      } else {
        var datos = {};
        fd.forEach(function (v, k) { if (typeof v === 'string') datos[k] = v; });
        opciones = {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify(datos)
        };
      }

      if (btn) {
        btn.disabled = true;
        btn.textContent = archivos.length ? 'Subiendo y abriendo el ticket…' : 'Abriendo el ticket…';
      }

      fetch(endpoint, opciones).then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, d: d }; });
      }).then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = etiquetaBtn; }
        if (res.ok) {
          var num = res.d && res.d.ticket ? ' Tu número de seguimiento es el ' + res.d.ticket + '.' : '';
          aviso('Ticket abierto.' + num + ' Te escribimos al correo que nos has dado.', 'ok', false);
          form.reset();
        } else {
          aviso((res.d && res.d.error) || 'No hemos podido abrir el ticket.', 'mal', true);
        }
      }).catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = etiquetaBtn; }
        aviso('No hemos podido conectar.', 'mal', true);
      });
    });

    /* Al elegir ficheros se dice cuáles y cuánto pesan. Sin esto no hay forma de saber
       si el navegador cogió lo que se quería, y el <input type=file> nativo solo dice
       «3 archivos». */
    var inp = raiz.querySelector('input[type="file"]');
    var pista = raiz.querySelector('[data-sop-adj-pista]');
    if (inp && pista) {
      var textoBase = pista.textContent;
      inp.addEventListener('change', function () {
        var fs = inp.files;
        if (!fs || !fs.length) { pista.textContent = textoBase; return; }
        var nombres = [], total = 0;
        for (var i = 0; i < fs.length; i++) { nombres.push(fs[i].name); total += fs[i].size; }
        var mb = (total / 1048576).toFixed(total < 104858 ? 2 : 1);
        pista.textContent = nombres.join(', ') + ' — ' + mb + ' MB en total';
      });
    }

    /* Al escribir en un campo marcado se le quita la marca: dejarla puesta hace que el
       formulario parezca roto aunque ya esté corregido. */
    form.addEventListener('input', function (e) {
      if (e.target && e.target.hasAttribute('aria-invalid')) e.target.removeAttribute('aria-invalid');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
